import App from '@/models/App'

export default class OrderingOrdererEstimateDiscount extends App {
    static get entity() {
        return 'OrderingOrdererEstimateDiscounts'
    }

    static all() {
        return this.query().get()
    }

    static fields() {
        return {
            id: this.attr(null),
            orderingEstimateId: this.attr(null),
            currency: this.attr(null),
            discountType: this.attr(null),
            discountPercentage: this.attr(null),
            discountPrice: this.attr(null),
            taxCategory: this.attr(null),
            taxRate: this.attr(null),
            createdAt: this.attr(null),
            updatedAt: this.attr(null),
        }
    }

    static apiConfig = {
        actions: {
            create(orderingShipId, orderingOrderId, orderingEstimateId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/estimates/${orderingEstimateId}/discounts`,
                    App.post(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(orderingShipId, orderingOrderId, orderingEstimateId, orderingEstimateDiscountId, params) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/estimates/${orderingEstimateId}/discounts/${orderingEstimateDiscountId}`,
                    App.patch(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(orderingShipId, orderingOrderId, orderingEstimateId, orderingEstimateDiscountId) {
                return this.delete(
                    `ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/estimates/${orderingEstimateId}/discounts/${orderingEstimateDiscountId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: orderingEstimateDiscountId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
